module.exports = __webpack_public_path__ + "media/images/icons/icons_large/7_flowers-f1110e8c8e4883bd6fa824911530039c.png";